module.exports = __webpack_public_path__ + "7219da78c3f884d57d172552ef1b9233.png";